import React from 'react';

import SeveritySegment from './SeveritySegment';
import { type AlarmSeverity, type AlarmsToTriageSegment } from './severity';

export interface SeverityBreakdownProps {
  /** Most severe first. Empty severities are dropped. */
  segments: AlarmsToTriageSegment[];
  onSegmentClick?: (severity: AlarmSeverity) => void;
}

/**
 * The proportional bar across the card. Widths are shares of the severities
 * actually shown, not of the card's total
 *
 * @param {SeverityBreakdownProps} props see SeverityBreakdownProps
 * @returns {JSX.Element|null} the row of segments, or null if every count is 0
 */
export default function SeverityBreakdown ({ segments, onSegmentClick }: SeverityBreakdownProps) {
  const shown = segments.filter((segment) => segment.count > 0);

  if (!shown.length) return null;

  return (
    <div className='ds-flex ds-items-stretch ds-gap-2' data-testid='alarms-to-triage-segments'>
      {shown.map(({ severity, count, label }) => (
        <SeveritySegment
          key={severity}
          severity={severity}
          count={count}
          label={label}
          onClick={onSegmentClick}
        />
      ))}
    </div>
  );
}
